<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">
                        TRANSACCIONES ON-CHAIN
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="refreshAll(true)">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4" md="3">
                                <v-select
                                    v-model="status"
                                    :items="statuses"
                                    item-text="text"
                                    item-value="value"
                                    label="Estado"
                                    prepend-icon="mdi-filter"
                                    @change="getTransfers(true)"/>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headers"
                            :items="transfers"
                            :loading="loading"
                            item-key="id"
                            dense>
                            <template v-slot:item.customer="{ item }">
                                <div class="font-weight-bold">{{ item.customer || 'Cliente' }}</div>
                                <div class="caption">{{ item.nickname }}</div>
                            </template>
                            <template v-slot:item.direction_label="{ item }">
                                <v-chip small :color="item.direction === 'inbound' ? 'success' : 'warning'" dark>
                                    {{ item.direction_label }}
                                </v-chip>
                            </template>
                            <template v-slot:item.asset="{ item }">
                                {{ item.asset }} / {{ item.network_label }}
                            </template>
                            <template v-slot:item.status_label="{ item }">
                                <v-chip small outlined color="primary">{{ item.status_label }}</v-chip>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon small color="primary" @click="open(item)">
                                    <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12">
                <v-card>
                    <v-card-title class="py-3">
                        <v-icon color="primary" class="mr-2">mdi-wallet-check</v-icon>
                        Barridos a billetera maestra
                        <v-spacer/>
                        <v-btn color="primary" depressed :disabled="sweepLoading" @click="openSweepDialog">
                            <v-icon left>mdi-plus-circle</v-icon>Registrar barrido
                        </v-btn>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4" md="3">
                                <v-select
                                    v-model="sweepStatus"
                                    :items="sweepStatuses"
                                    item-text="text"
                                    item-value="value"
                                    label="Estado"
                                    prepend-icon="mdi-filter"
                                    @change="getSweeps(true)"/>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="sweepHeaders"
                            :items="sweeps"
                            :loading="sweepLoading"
                            item-key="id"
                            dense
                            no-data-text="No hay barridos registrados">
                            <template v-slot:item.customer="{ item }">
                                <div class="font-weight-bold">{{ item.customer || 'Cliente' }}</div>
                                <div class="caption">{{ item.nickname }}</div>
                            </template>
                            <template v-slot:item.asset="{ item }">
                                {{ item.asset }} / {{ item.network_label }}
                            </template>
                            <template v-slot:item.status_label="{ item }">
                                <v-chip small outlined color="primary">{{ item.status_label }}</v-chip>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon small color="primary" @click="openSweep(item)">
                                    <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" persistent scrollable max-width="760px">
            <v-card v-if="selected">
                <v-card-title class="primary secondary--text">
                    {{ selected.direction_label }} {{ selected.asset }} - {{ selected.status_label }}
                    <v-spacer/>
                    <v-btn icon color="secondary" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-alert dense text type="warning" class="ma-4 mb-0" v-if="selected.direction === 'outbound' && (selected.can_submit || selected.can_confirm)">
                    Revise la direccion, red y monto antes de continuar. Una transaccion enviada a la red no se puede deshacer.
                </v-alert>
                <v-card-text class="pt-4">
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Cliente</v-list-item-title>
                                <v-list-item-subtitle>{{ selected.customer }} {{ selected.nickname }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Monto a enviar</v-list-item-title>
                                <v-list-item-subtitle>{{ selected.amount }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.direction === 'outbound' && selected.raw_valzum_fee_amount > 0">
                            <v-list-item-content>
                                <v-list-item-title>Comision Valzum</v-list-item-title>
                                <v-list-item-subtitle>{{ selected.valzum_fee_amount }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.direction === 'outbound' && selected.raw_network_fee_amount > 0">
                            <v-list-item-content>
                                <v-list-item-title>Reserva de red</v-list-item-title>
                                <v-list-item-subtitle>{{ selected.network_fee_amount }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.direction === 'outbound' && selected.raw_total_debit_amount !== selected.raw_amount">
                            <v-list-item-content>
                                <v-list-item-title>Total descontado</v-list-item-title>
                                <v-list-item-subtitle>{{ selected.total_debit_amount }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.destination_address">
                            <v-list-item-content>
                                <v-list-item-title>Direccion destino</v-list-item-title>
                                <v-list-item-subtitle class="text-break">{{ selected.destination_address }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.source_address">
                            <v-list-item-content>
                                <v-list-item-title>Direccion origen</v-list-item-title>
                                <v-list-item-subtitle class="text-break">{{ selected.source_address }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.tx_hash">
                            <v-list-item-content>
                                <v-list-item-title>Hash</v-list-item-title>
                                <v-list-item-subtitle class="text-break">{{ selected.tx_hash }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selected.error_message">
                            <v-list-item-content>
                                <v-list-item-title>Error</v-list-item-title>
                                <v-list-item-subtitle class="error--text">{{ selected.error_message }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-textarea
                        v-if="selected.can_reject"
                        v-model="reason"
                        label="Motivo de rechazo"
                        rows="2"
                        prepend-icon="mdi-note-text"/>
                    <v-text-field
                        v-if="selected.can_confirm"
                        v-model="txHash"
                        label="Hash de confirmacion"
                        prepend-icon="mdi-pound"/>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-btn text color="error" @click="dialog = false" :disabled="actionLoading">Cerrar</v-btn>
                    <v-spacer/>
                    <v-btn v-if="selected.can_reject" color="error" outlined :loading="actionLoading" @click="reject">
                        <v-icon left small>mdi-close-circle</v-icon>Rechazar
                    </v-btn>
                    <v-btn v-if="selected.can_approve" color="success" :loading="actionLoading" @click="approve">
                        <v-icon left small>mdi-check-circle</v-icon>Aprobar
                    </v-btn>
                    <v-btn v-if="selected.can_submit" color="primary" :loading="actionLoading" @click="submit">
                        <v-icon left small>mdi-send</v-icon>Enviar
                    </v-btn>
                    <v-btn v-if="selected.can_confirm" color="success" :loading="actionLoading" @click="confirm">
                        <v-icon left small>mdi-check-decagram</v-icon>Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="sweepDialog" persistent scrollable max-width="720px">
            <v-card>
                <v-form ref="sweepForm" v-model="sweepValid" @submit.prevent="requestSweep" lazy-validation>
                    <v-card-title class="primary secondary--text">
                        <v-icon color="secondary" class="mr-2">mdi-wallet-check</v-icon>
                        Registrar barrido
                        <v-spacer/>
                        <v-btn icon color="secondary" @click="sweepDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="pt-4">
                        <v-alert dense outlined type="info" v-if="sweepAddresses.length === 0">
                            No hay direcciones activas o falta configurar billeteras maestras.
                        </v-alert>
                        <v-select
                            v-model="sweepForm.wallet_crypto_address_id"
                            :items="sweepAddresses"
                            :item-text="sweepAddressLabel"
                            item-value="id"
                            label="Direccion de origen"
                            prepend-icon="mdi-wallet-outline"
                            :rules="[rules.required('wallet_crypto_address_id')]"
                            :disabled="sweepActionLoading"/>
                        <v-text-field
                            v-model.number="sweepForm.amount"
                            label="Monto a barrer"
                            type="number"
                            min="0"
                            step="0.00000001"
                            prepend-icon="mdi-cash-fast"
                            :rules="[rules.required('amount')]"
                            :disabled="sweepActionLoading"/>
                        <v-textarea
                            v-model="sweepForm.note"
                            label="Nota operativa"
                            rows="2"
                            prepend-icon="mdi-note-text"
                            :disabled="sweepActionLoading"/>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-btn text color="error" @click="sweepDialog = false" :disabled="sweepActionLoading">Cerrar</v-btn>
                        <v-spacer/>
                        <v-btn type="submit" color="success" :loading="sweepActionLoading" :disabled="sweepActionLoading || !sweepValid || sweepAddresses.length === 0">
                            <v-icon left small>mdi-check-circle</v-icon>Guardar
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="sweepDetailDialog" persistent scrollable max-width="760px">
            <v-card v-if="selectedSweep">
                <v-card-title class="primary secondary--text">
                    Barrido {{ selectedSweep.asset }} - {{ selectedSweep.status_label }}
                    <v-spacer/>
                    <v-btn icon color="secondary" @click="sweepDetailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Cliente</v-list-item-title>
                                <v-list-item-subtitle>{{ selectedSweep.customer }} {{ selectedSweep.nickname }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Monto</v-list-item-title>
                                <v-list-item-subtitle>{{ selectedSweep.amount }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Origen</v-list-item-title>
                                <v-list-item-subtitle class="text-break">{{ selectedSweep.source_address }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Destino maestro</v-list-item-title>
                                <v-list-item-subtitle class="text-break">{{ selectedSweep.destination_address }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selectedSweep.destination_tag">
                            <v-list-item-content>
                                <v-list-item-title>Tag/Memo</v-list-item-title>
                                <v-list-item-subtitle>{{ selectedSweep.destination_tag }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selectedSweep.tx_hash">
                            <v-list-item-content>
                                <v-list-item-title>Hash</v-list-item-title>
                                <v-list-item-subtitle class="text-break">{{ selectedSweep.tx_hash }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="selectedSweep.error_message">
                            <v-list-item-content>
                                <v-list-item-title>Error</v-list-item-title>
                                <v-list-item-subtitle class="error--text">{{ selectedSweep.error_message }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-textarea
                        v-if="selectedSweep.can_reject"
                        v-model="sweepReason"
                        label="Motivo de rechazo"
                        rows="2"
                        prepend-icon="mdi-note-text"/>
                    <v-text-field
                        v-if="selectedSweep.can_confirm"
                        v-model="sweepTxHash"
                        label="Hash de confirmacion"
                        prepend-icon="mdi-pound"/>
                    <v-text-field
                        v-if="selectedSweep.can_confirm"
                        v-model="sweepProviderTransferId"
                        label="ID proveedor"
                        prepend-icon="mdi-identifier"/>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-btn text color="error" @click="sweepDetailDialog = false" :disabled="sweepActionLoading">Cerrar</v-btn>
                    <v-spacer/>
                    <v-btn v-if="selectedSweep.can_reject" color="error" outlined :loading="sweepActionLoading" @click="rejectSweep">
                        <v-icon left small>mdi-close-circle</v-icon>Rechazar
                    </v-btn>
                    <v-btn v-if="selectedSweep.can_confirm" color="success" :loading="sweepActionLoading" @click="confirmSweep">
                        <v-icon left small>mdi-check-decagram</v-icon>Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../../helpers/form";

export default {
    name: "CryptoTransfers",
    mixins: [Form],
    props: ['user'],
    data: () => ({
        loading: false,
        actionLoading: false,
        dialog: false,
        sweepDialog: false,
        sweepDetailDialog: false,
        selected: null,
        selectedSweep: null,
        reason: '',
        txHash: '',
        sweepReason: '',
        sweepTxHash: '',
        sweepProviderTransferId: '',
        status: 'pending_review',
        sweepStatus: 'pending_review',
        sweepLoading: false,
        sweepActionLoading: false,
        sweepValid: true,
        sweepForm: {
            wallet_crypto_address_id: null,
            amount: null,
            note: ''
        },
        statuses: [
            { text: 'Pendientes', value: 'pending_review' },
            { text: 'Aprobadas', value: 'approved' },
            { text: 'Enviadas', value: 'submitted' },
            { text: 'Completadas', value: 'completed' },
            { text: 'Rechazadas', value: 'rejected' },
            { text: 'Todas', value: 'all' }
        ],
        sweepStatuses: [
            { text: 'Pendientes', value: 'pending_review' },
            { text: 'Aprobados', value: 'approved' },
            { text: 'Enviados', value: 'submitted' },
            { text: 'Completados', value: 'completed' },
            { text: 'Rechazados', value: 'rejected' },
            { text: 'Todos', value: 'all' }
        ],
        headers: [
            { text: 'Fecha', value: 'created_at' },
            { text: 'Cliente', value: 'customer' },
            { text: 'Tipo', value: 'direction_label' },
            { text: 'Activo', value: 'asset' },
            { text: 'Monto', value: 'amount' },
            { text: 'Total', value: 'total_debit_amount' },
            { text: 'Estado', value: 'status_label' },
            { text: '', value: 'actions', sortable: false, align: 'end' }
        ],
        sweepHeaders: [
            { text: 'Fecha', value: 'created_at' },
            { text: 'Cliente', value: 'customer' },
            { text: 'Activo', value: 'asset' },
            { text: 'Monto', value: 'amount' },
            { text: 'Fee red', value: 'network_fee_estimate' },
            { text: 'Estado', value: 'status_label' },
            { text: '', value: 'actions', sortable: false, align: 'end' }
        ],
        transfers: [],
        sweeps: [],
        sweepAddresses: []
    }),
    created() {
        this.refreshAll();
    },
    methods: {
        refreshAll(reset) {
            this.getTransfers(reset);
            this.getSweeps(reset);
        },
        getTransfers(reset) {
            if (reset) {
                this.transfers = [];
            }

            this.loading = true;
            axios.get('/api/wallet/crypto/transfers', {params: {status: this.status}}).then(res => {
                this.transfers = res.data.transfers || [];
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar transacciones on-chain.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        getSweeps(reset) {
            if (reset) {
                this.sweeps = [];
            }

            this.sweepLoading = true;
            axios.get('/api/wallet/crypto/sweeps', {params: {status: this.sweepStatus}}).then(res => {
                this.sweeps = res.data.sweeps || [];
                this.sweepAddresses = (res.data.addresses || []).filter(item => item.master_ready);
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar barridos.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.sweepLoading = false;
            });
        },
        open(item) {
            this.selected = item;
            this.reason = '';
            this.txHash = item.tx_hash || '';
            this.dialog = true;
        },
        openSweepDialog() {
            this.sweepForm = {
                wallet_crypto_address_id: this.sweepAddresses.length ? this.sweepAddresses[0].id : null,
                amount: null,
                note: ''
            };
            this.sweepDialog = true;
        },
        openSweep(item) {
            this.selectedSweep = item;
            this.sweepReason = '';
            this.sweepTxHash = item.tx_hash || '';
            this.sweepProviderTransferId = item.provider_transfer_id || '';
            this.sweepDetailDialog = true;
        },
        sweepAddressLabel(item) {
            const owner = item.nickname || item.customer || item.email || ('Direccion #' + item.id);
            return item.asset + ' / ' + item.network_label + ' - ' + owner;
        },
        requestSweep() {
            if (!this.$refs.sweepForm.validate()) return;

            this.sweepActionLoading = true;
            axios.post('/api/wallet/crypto/sweeps', this.sweepForm).then(res => {
                this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                this.sweepDialog = false;
                this.getSweeps(true);
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible registrar el barrido.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.sweepActionLoading = false;
            });
        },
        rejectSweep() {
            if (!this.sweepReason) {
                this.$toast.warning('Ingrese el motivo de rechazo.', {icon: 'mdi-alert-circle'});
                return;
            }

            this.sweepAction('reject', {reason: this.sweepReason}, 'Barrido rechazado.');
        },
        confirmSweep() {
            if (!this.sweepTxHash) {
                this.$toast.warning('Ingrese el hash de confirmacion.', {icon: 'mdi-alert-circle'});
                return;
            }

            this.sweepAction('confirm', {
                tx_hash: this.sweepTxHash,
                provider_transfer_id: this.sweepProviderTransferId
            }, 'Barrido confirmado.');
        },
        sweepAction(action, payload, fallback) {
            if (!this.selectedSweep) {
                return;
            }

            this.sweepActionLoading = true;
            axios.post('/api/wallet/crypto/sweeps/' + this.selectedSweep.id + '/' + action, payload || {}).then(res => {
                this.$toast.success(res.data.status || fallback, {icon: 'mdi-check-circle'});
                this.sweepDetailDialog = false;
                this.getSweeps(true);
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible actualizar el barrido.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.sweepActionLoading = false;
            });
        },
        approve() {
            this.confirmAction(
                'approve',
                '¿Aprobar esta transaccion?',
                'La solicitud quedara lista para envio operativo.',
                'Transaccion aprobada.'
            );
        },
        submit() {
            this.confirmAction(
                'submit',
                '¿Enviar esta transaccion a la red?',
                'Confirme que direccion, red y monto ya fueron revisados.',
                'Transaccion enviada.'
            );
        },
        confirm() {
            if (!this.txHash) {
                this.$toast.warning('Ingrese el hash de confirmacion.', {icon: 'mdi-alert-circle'});
                return;
            }

            this.confirmAction(
                'confirm',
                '¿Confirmar esta transaccion?',
                'El movimiento quedara marcado como completado.',
                'Transaccion confirmada.',
                {tx_hash: this.txHash}
            );
        },
        reject() {
            if (!this.reason) {
                this.$toast.warning('Ingrese el motivo de rechazo.', {icon: 'mdi-alert-circle'});
                return;
            }

            this.confirmAction(
                'reject',
                '¿Rechazar esta transaccion?',
                'El saldo bloqueado se devolvera al cliente cuando aplique.',
                'Transaccion rechazada.',
                {reason: this.reason}
            );
        },
        confirmAction(action, title, text, fallback, payload) {
            this.$swal({
                title,
                text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, continuar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    this.action(action, fallback, payload);
                }
            });
        },
        action(action, fallback, payload) {
            if (!this.selected) {
                return;
            }

            this.actionLoading = true;
            axios.post('/api/wallet/crypto/transfers/' + this.selected.id + '/' + action, payload || {}).then(res => {
                this.$toast.success(res.data.status || fallback, {icon: 'mdi-check-circle'});
                this.dialog = false;
                this.getTransfers(true);
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible actualizar la transaccion.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.actionLoading = false;
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>
